



































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import ResearchLine from '@/models/coding/researchLine/researchLine.model';
@Component
export default class ResearchLineAdd extends GenericAdd<ResearchLine> {
  constructor() {
    super();
    this.controller = 'ResearchLines';
    this.model = new ResearchLine();
  }
  saveAll(){
      this.model.fieldAreaId = this.$route.params.fieldAreaId as any;
      return this.validate();
  }
  public convertirAMinuscula(event: any) {
    this.model.key = event.target.value.toLowerCase();
  }
}
